<template>
  <section
    id="values-goals"
    class="relative py-20 bg-gradient-to-b from-slate-50 to-white dark:from-slate-800 dark:to-slate-900"
  >
    <div class="container relative">
      <!-- Heading -->
      <div class="mb-12 text-center">
        <h6 class="mb-2 text-sm font-semibold tracking-widest uppercase text-primary">
          {{ t('values_tag') }}
        </h6>
        <h3 class="text-3xl font-bold leading-normal text-slate-900 dark:text-white">
          {{ t('values_h') }}
        </h3>
        <p class="max-w-2xl mx-auto mt-3 text-slate-600 dark:text-slate-400">
          {{ t('values_p') }}
        </p>
      </div>

      <!-- Values (4 cards) -->
      <div
        class="grid max-w-6xl grid-cols-1 gap-6 mx-auto mb-16 sm:grid-cols-2 lg:grid-cols-4"
      >
        <div
          v-for="(v, i) in valuesSchema"
          :key="'value-' + i"
          class="relative transition-all duration-500 border shadow-sm group p-7 rounded-2xl hover:-translate-y-2 bg-slate-50/60 dark:bg-slate-800/50 border-slate-200 dark:border-slate-600 hover:shadow-lg"
        >
          <div class="flex items-center justify-center rounded-full w-14 h-14 bg-secondary/40 text-primary">
            <i :class="v.icon" class="text-2xl"></i>
          </div>

          <h4 class="mt-3 text-lg font-semibold text-slate-900 dark:text-white group-hover:text-primary">
            {{ t(v.titleKey) }}
          </h4>

          <!-- description kept (short + optional) -->
          <p
            v-if="t(v.descKey) !== v.descKey"
            class="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-400"
          >
            {{ t(v.descKey) }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { messages } from '@/i18n';

export default {
  data() {
    const initial =
      (document.documentElement.lang || localStorage.getItem('app_lang') || 'ar').toLowerCase();
    return {
      messages,
      lang: initial.startsWith('en') ? 'en' : 'ar',
      _langObserver: null,
      _langHandler: null,

      // Exactly your four values
      valuesSchema: [
        { icon: 'mdi mdi-star-circle',  titleKey: 'val_digital_lead_title',  descKey: 'val_digital_lead_desc' },
        { icon: 'mdi mdi-leaf',         titleKey: 'val_sustain_emp_title',   descKey: 'val_sustain_emp_desc' },
        { icon: 'mdi mdi-handshake',    titleKey: 'val_strat_part_title',    descKey: 'val_strat_part_desc' },
        { icon: 'mdi mdi-certificate',  titleKey: 'val_auth_quality_title',  descKey: 'val_auth_quality_desc' },
      ],
    };
  },

  mounted() {
    // Listen for navbar broadcast (instant live switch)
    this._langHandler = (e) => {
      const next = (e.detail || 'ar').toLowerCase().startsWith('en') ? 'en' : 'ar';
      if (next !== this.lang) this.lang = next;
    };
    window.addEventListener('app:lang', this._langHandler, { passive: true });

    // Fallback: watch <html lang/dir>
    this._langObserver = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'attributes' && (m.attributeName === 'lang' || m.attributeName === 'dir')) {
          const htmlLang = (document.documentElement.lang || 'ar').toLowerCase();
          const next = htmlLang.startsWith('en') ? 'en' : 'ar';
          if (next !== this.lang) this.lang = next;
        }
      }
    });
    this._langObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang', 'dir'],
    });
  },

  beforeUnmount() {
    if (this._langObserver) this._langObserver.disconnect();
    if (this._langHandler) window.removeEventListener('app:lang', this._langHandler);
  },

  methods: {
    t(key) {
      return (this.messages[this.lang] && this.messages[this.lang][key]) || key;
    },
  },
};
</script>
